import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BookingPackageType,
  BookingTariffType,
  RemoveBookingWorkshop,
  SetBookingWorkshop
} from '@products/models/booking.model';
import { RemoveContingentReservation, SetContingentReservationDate } from '@products/models/contingent.model';
import { SetAmanoParkingReservationDate } from '@products/models/parking.model';
import {
  GetProducts,
  RemovePackageBooking,
  RemovePackageTariffBooking,
  RemoveTariffBooking,
  SetPreferredTariffBooking
} from '@products/models/products.model';
import { PromoCode } from '@products/models/smart-promotions';
import {
  ReleaseVoucher,
  RemoveVoucher,
  RemoveVoucherTariffBooking,
  SetRedeemedVoucher,
  SetVoucher,
  VoucherCode
} from '@products/models/voucher.model';

export const LoadProductsActions = createActionGroup({
  source: 'Load Products',
  events: {
    'Get products': props<GetProducts>(),
    'Get preferred products': props<GetProducts>(),
    'Get workshop products': (eventId: number) => ({ eventId })
  }
});

export const TariffProductActions = createActionGroup({
  source: 'Tariff Product',
  events: {
    'Set tariff booking': (bookingTariffTypes: BookingTariffType[]) => ({ bookingProductTypes: bookingTariffTypes }),
    'Set preferred tariff booking': props<SetPreferredTariffBooking>(),
    'Set self registration tariff bookings': (bookingTariffTypes: BookingTariffType[]) => ({
      bookingProductTypes: bookingTariffTypes
    }),
    'Remove tariff booking': props<RemoveTariffBooking>()
  }
});

export const VoucherProductActions = createActionGroup({
  source: 'Voucher Product',
  events: {
    'Redeem and release voucher': props<SetVoucher>(),
    'Set redeemed and release vouchers in product bookings and product selection': props<SetRedeemedVoucher>(),
    'Release voucher': props<ReleaseVoucher>(),
    'Release expired voucher': props<ReleaseVoucher>(),
    'Remove released voucher': props<RemoveVoucher>(),
    'Remove released and removed product booking voucher from product selection': (voucherCode: VoucherCode) => ({
      voucherCode
    }),
    'Set voucher tariff booking': (bookingTariffTypes: BookingTariffType[]) => ({
      bookingProductTypes: bookingTariffTypes
    }),
    'Remove Voucher tariff booking': props<RemoveVoucherTariffBooking>()
  }
});

export const WorkshopProductActions = createActionGroup({
  source: 'Workshop Product',
  events: {
    'Set booking workshop': (setBookingWorkshops: SetBookingWorkshop[]) => ({
      setBookingWorkshops
    }),
    'Remove booking workshop': (removeBookingWorkshops: RemoveBookingWorkshop[]) => ({
      removeBookingWorkshops
    })
  }
});

export const ContingentProductActions = createActionGroup({
  source: 'Contingent Product',
  events: {
    'Set contingent booking reservation': (contingentReservationDates: SetContingentReservationDate[]) => ({
      contingentReservationDates
    }),
    'Remove contingent booking reservation': (removeContingentReservations: RemoveContingentReservation[]) => ({
      removeContingentReservations
    })
  }
});

export const AmanoParkingProductActions = createActionGroup({
  source: 'Amano Parking Product',
  events: {
    'Set amano parking booking reservation': (amanoParkingReservationDate: SetAmanoParkingReservationDate) => ({
      amanoParkingReservationDate
    })
  }
});

export const PackageProductActions = createActionGroup({
  source: 'Package Product',
  events: {
    'Set package booking': (bookingPackageTypes: BookingPackageType[]) => ({
      bookingProductTypes: bookingPackageTypes
    }),
    'Remove package booking': props<RemovePackageBooking>(),
    'Set package tariff booking': (bookingPackageTypes: BookingPackageType[]) => ({
      bookingProductTypes: bookingPackageTypes
    }),
    'Remove package tariff booking': props<RemovePackageTariffBooking>()
  }
});

export const SmartPromotionActions = createActionGroup({
  source: 'Smart Promotion',
  events: {
    'Redeem promo code': (redeemPromoCode: PromoCode) => ({
      redeemPromoCode
    }),
    'Redeem promo code on confirmation step init': emptyProps(),
    'Remove unredeemed promo code': (removePromoCode: PromoCode) => ({
      removePromoCode
    }),
    'Remove redeemed promo code': (removePromoCode: PromoCode) => ({
      removePromoCode
    })
  }
});

export const ResetProductsActions = createActionGroup({
  source: 'Products Reset',
  events: {
    'Reset product selection reducer': emptyProps(),
    'Reset booking reducer': emptyProps(),
    'Reset workshop reducer': emptyProps(),
    'Reset holder reducer': emptyProps(),
    'Reset status reducer': emptyProps()
  }
});
